import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext({ user: null, setUser: () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await api.get("/auth/me");
        setUser(res.data);
      } catch {
        try {
          await api.post("/auth/refresh");
          const res = await api.get("/auth/me");
          setUser(res.data);
        } catch {
          setUser(false);
        }
      }
    };
    check();
  }, []);

  return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
